import cubejsApi from "lib/cube-js";
import { debounce } from "lodash";

export const createFetchOptionsFn = (name, secondaryIdDimension) =>
  debounce((query, callback) => {
    let dimensions = [name];
    if (secondaryIdDimension) {
      dimensions.push(secondaryIdDimension);
    }
    return cubejsApi
      .load({
        dimensions: dimensions,
        measures: [],
        timeDimensions: [],
        filters: [
          {
            member: name,
            operator: "contains",
            values: [query ?? ""],
          },
        ],
        limit: 50,
      })
      .then((result) => {
        const response = result.pivot().map((item) => {
          return {
            value: item["xValues"][0],
            label: item["xValues"][0],
            idDimension: secondaryIdDimension ?? undefined,
            idDimensionValue: item["xValues"][1] ?? undefined,
          };
        });
        callback(response);
        return response;
      })
      .catch((err) => {
        callback([]);
      });
  }, 300);
